<div class="container-course">
	<section class="header-education">
		<div class="container_education">
			<div class="header-education__inner">
				<a href="/education" class="header-education__btn-back">
					<img class="header-education__icon-back" src="assets/images/education/icons/icon__back-arrow.svg" alt="">
					Назад
				</a>

				<a href="/">
					<img class="logo" src="assets/images/education/icon__logo.svg" alt="">
				</a>
			</div>
		</div>
	</section>

	<section class="hero">
		<div class="container_education">

			<div class="hero__inner">

				<div class="hero__content">
					<h1 class="hero__title">Знакомьтесь, эккаунт</h1>
					<h2 class="hero__subtitle"><span>Эккаунт</span> — это тот, кто...</h2>
				</div>

				<div class="hero__characteristics">
					<div class="hero__item">менеджерит рабочий процесс «клиент — агентство»</div>
					<div class="hero__item">организовывает командную работу на проекте</div>
					<div class="hero__item hero__item--width">отвечает за проектные тайминги и сметы</div>
					<div class="hero__item">выстраивает доверительные долгосрочные отношения с клиентами</div>
				</div>
			</div>
		</div>
	</section>

	<section class="characteristic">
		<div class="container_education">
			<h2 class="section-title characteristic__title">Ты нам подходишь, если ты:</h2>
			<div class="characteristic__inner">
				<div class="characteristic__card">
					<img class="characteristic__icon" src="assets/images/education/course-page/course-page__characteristics-01.svg" alt="">
					<div class="characteristic__text">не боишься многозадачности </div>
				</div>
				<div class="characteristic__card">
					<img class="characteristic__icon" src="assets/images/education/course-page/course-page__characteristics-02.svg" alt="">
					<div class="characteristic__text">знаком с понятием тайм-менеджмента </div>
				</div>
				<div class="characteristic__card">
					<img class="characteristic__icon" src="assets/images/education/course-page/course-page__characteristics-03.svg" alt="">
					<div class="characteristic__text">умеешь находить общий язык с людьми </div>
				</div>
				<div class="characteristic__card">
					<img class="characteristic__icon" src="assets/images/education/course-page/course-page__characteristics-04.svg" alt="">
					<div class="characteristic__text">способен видеть креативные подходы к решению задач</div>
				</div>
				<div class="characteristic__card">
					<img class="characteristic__icon" src="assets/images/education/course-page/course-page__characteristics-05.svg" alt="">
					<div class="characteristic__text">можешь грамотно говорить и писать</div>
				</div>
				<div class="characteristic__card">
					<img class="characteristic__icon" src="assets/images/education/course-page/course-page__characteristics-06.svg" alt="">
					<div class="characteristic__text">обладаешь навыками работы в программах MS Office</div>
				</div>
			</div>
		</div>
	</section>

	<section class="curators">
		<div class="container_education">
			<h2 class="section-title section-title--black curators__title">Наши кураторы:</h2>
			<div class="curators__inner curators__inner--mobile">
				<div class="curators__card" *ngFor="let data of curatorsList" id={{data.id}}>
					<div class="curators__animation-photo">
						<img *ngIf="data.image_path" class="curators__photo" src="{{environment.url}}{{data.image_path}}" alt="">
						<img *ngIf="!data.image_path" class="curators__photo" src="assets/images/education/course-page/photo__curator.png" alt="">
					</div>
					<div class="curators__name">{{data.name}}</div>
				</div>
			</div>

			<div class="swiper-container curators__slider">
				<div class="swiper-wrapper">
					<div class="swiper-slide curators__card" *ngFor="let data of curatorsList">
						<div class="curators__animation-photo">
							<img *ngIf="data.image_path" class="curators__photo" src="{{environment.url}}{{data.image_path}}" alt="">
							<img *ngIf="!data.image_path" class="curators__photo" src="assets/images/education/course-page/photo__curator.png" alt="">
						</div>
						<div class="curators__name">{{data.name}}</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="active-courses">
		<div class="container_education">
			<h2 class="section-title active-courses__title">Открытые стажировки</h2>

			<div class="active-courses__inner">
				<div *ngFor="let data of internshipsDirections">
					<app-course-card [data]="data"
									 [idDirection]="idCourse"
									 [course]="true">
					</app-course-card>
				</div>
			</div>
		</div>
	</section>

	<section class="line-text">
		<div class="line-text__inner">
			<div class="line-text__item line-text__item--bold">Подпишись на анонсы стажировок</div>
			<div class="line-text__item line-text__item--stroke">Подпишись на анонсы стажировок</div>
			<div class="line-text__item line-text__item--bold">Подпишись на анонсы стажировок</div>
			<div class="line-text__item line-text__item--stroke">Подпишись на анонсы стажировок</div>
		</div>
		<div aria-hidden="true" class="line-text__inner">
			<div class="line-text__item line-text__item--bold">Подпишись на анонсы стажировок</div>
			<div class="line-text__item line-text__item--stroke">Подпишись на анонсы стажировок</div>
			<div class="line-text__item line-text__item--bold">Подпишись на анонсы стажировок</div>
			<div class="line-text__item line-text__item--stroke">Подпишись на анонсы стажировок</div>
		</div>
	</section>

	<app-form-new-course></app-form-new-course>
</div>

<app-successful-sending></app-successful-sending>
<app-take-test></app-take-test>
